import billingAccount, { BillingAccount } from './billingAccount';

export interface Account {
  id: number;
  billing_account_id?: number;
  billing_account?: BillingAccount;
  first_name?: string;
  last_name?: string;
  contact_number?: string;
  email?: string;

  billing_email?: string;
  company_name?: string;
  company_vat_number?: string;

  created_at?: string;
  updated_at?: string;
}

export interface AccountAgent {
  id: number;
  billing_account_id?: number;
  billing_account?: BillingAccount;
  first_name?: string;
  last_name?: string;
  contact_number?: string;
  email?: string;

  billing_email?: string;
  company_name?: string;
  company_vat_number?: string;

  created_at?: string;
  updated_at?: string;

  active?: boolean;
}

function New(): Account {
  return { id: 0 };
}

function Clone(acc: Account): Account {
  return {
    id: acc.id,
    billing_account_id: acc.billing_account_id,
    billing_account: acc.billing_account,
    first_name: acc.first_name,
    last_name: acc.last_name,
    contact_number: acc.contact_number,
    email: acc.email,

    billing_email: acc.billing_email,
    company_name: acc.company_name,
    company_vat_number: acc.company_vat_number,

    created_at: acc.created_at,
    updated_at: acc.updated_at,
  };
}

function DisplayText(acc?: Account) {
  if (!acc || !acc.id || acc.id === 0) { return ""; }
  if (acc.billing_account) {
    if (acc.billing_account.name) {
      return `${acc.billing_account.first_name} ${acc.billing_account.last_name} (${acc.id}) - ${acc.billing_account.name}`;
    }
    if (acc.billing_account.first_name || acc.billing_account.last_name) {
      return `${acc.billing_account.first_name} ${acc.billing_account.last_name} (${acc.id})`;
    }
  }
  if (acc.first_name || acc.last_name) {
    return `${acc.first_name} ${acc.last_name} (${acc.id})`;
  }
  return `${acc.email} (${acc.id})` || 'No Account Selected';
}

function ValidBasic(acc?: Account) {
  if (!acc) { return false; }
  if (acc.first_name && acc.last_name && acc.email && acc.contact_number) { return true; }
  return false;
}

function ValidBilling(acc?: Account) {
  if (!acc) { return false; }
  if (acc.billing_account_id || acc.billing_account) { return true; }
  return false;
}

function Same(acc1?: Account, acc2?: Account) {
  if (acc1 === acc2) { return true; }
  if (!acc1 && acc2) { return false; }
  if (acc1 && !acc2) { return false; }
  if (!acc1 || !acc2) { return false; }

  return (acc1.id === acc2.id) &&
    (acc1.first_name === acc2.first_name) &&
    (acc1.last_name === acc2.last_name) &&
    (acc1.contact_number === acc2.contact_number) &&
    (acc1.email === acc2.email) &&
    (acc1.billing_account_id === acc2.billing_account_id);
}

function Valid(acc?: Account) {
  return ValidBasic(acc); // && ValidBilling(acc); // billing not required anymore
}

export default {
  New,
  Clone,
  DisplayText,
  ValidBasic,
  ValidBilling,
  Valid,
  Same
};
